import { useMemo } from 'react';

import { Skeleton } from '~/components/Skeleton';
import { cn } from '~/lib/cn';
import { TableCell, TableRow } from '~/modules/artist-roster/components/Table';

interface PreReleaseSkeletonTableProps {
  size: number;
  headers: { id: string }[];
  cellClassName?: string;
  lineClassName?: string;
}

export function PreReleaseSkeletonTable({
  size,
  headers,
  lineClassName,
  cellClassName,
}: PreReleaseSkeletonTableProps) {
  const items = useMemo(() => Array.from({ length: size }), [size]);

  return items.map((_, rowIndex) => (
    <TableRow key={rowIndex}>
      {headers.map((cell, colIndex) => (
        <TableCell
          key={cell.id}
          className={cn(
            'border-y p-0 py-md pr-sm border-transparent first:rounded-l-sm last:rounded-r-sm',
            rowIndex % 2 === 0 && 'bg-default-inverse/default',
            cellClassName,
          )}
        >
          <div className="space-y-sm">
            {colIndex === 0 ? (
              <div className="flex items-center space-x-md pl-lg">
                <Skeleton
                  className={cn(
                    'size-[3rem] place-self-center rounded-xs object-cover bg-level-02',
                  )}
                />
                <Skeleton
                  className={cn(
                    'h-md w-[8em] rounded-sm bg-level-04',
                    lineClassName,
                  )}
                />
              </div>
            ) : (
              <Skeleton
                className={cn(
                  'mr-xl h-md w-auto rounded-sm bg-level-04',
                  lineClassName,
                )}
              />
            )}
          </div>
        </TableCell>
      ))}
    </TableRow>
  ));
}
